import ApprovalContents from '@/components/MobileApproval/ApprovalContents';
import { Approval, TotalApprovalParams } from '@/types/api';
import useSWRInfinite from 'swr/infinite';
import { getApprovalkey, MAX_LIST_SIZE } from '@/components/MobileApproval';
import { APPROVAL_SEARCH_URL } from '@/constant/approval';
import { approvalSearchListFetcher } from '@/hooks/apiHooks/approval';
import { useSaveApprovalSearch, useSearchApproval } from '@/hooks/apiHooks';
import Loading from '@/components/MobileApproval/Body/Loading';
import { useEffect } from 'react';

type P = {
  keyword?: string;
};

const SearchApproval = ({ keyword }: P) => {
  const approvalParams: TotalApprovalParams = {
    listSize: 20,
    sortType: 'authoredAt',
    orderType: 'desc',
    keyword: keyword,
  };

  const { data: countData } = useSearchApproval(approvalParams);

  useEffect(() => {
    keyword && useSaveApprovalSearch(keyword);
  }, [keyword]);

  const { data, size, setSize, isLoading, mutate } = useSWRInfinite<Approval[]>(
    getApprovalkey(APPROVAL_SEARCH_URL, approvalParams),
    approvalSearchListFetcher<Approval>,
  );

  const resultData = data?.reduce((prev, next) => prev.concat(next));
  const isReachingEnd = data && data[data.length - 1]?.length < MAX_LIST_SIZE;

  const readMoreData = () => {
    setSize(size + 1);
  };

  return (
    <div style={{ marginTop: '20px', padding: '0px 8px' }}>
      <div style={{ fontSize: '14px' }}>
        총{' '}
        <span style={{ color: 'var(--dk-accent, #06C)', fontWeight: '700' }}>
          {countData?.meta.totalCount || 0}
        </span>
        건
      </div>
      <ApprovalContents data={resultData} onRefresh={() => mutate()} />
      {!isLoading && !isReachingEnd && <Loading readMoreData={readMoreData} />}
    </div>
  );
};

export default SearchApproval;
